export default "__VITE_ASSET__c644db4f__"